import { useTranslation } from 'react-i18next';

import { WebLink, WebLinkProps } from '../WebLink';
import { withTranslation } from '../../locales/hoc';

const PLETLY_PRIVACY_POLICY_URL = 'https://www.pletly.com/privacy';

const PrivacyPolicyLinkBase = ({ children, ...textProps }: Props) => {
	const { t } = useTranslation();

	return (
		<WebLink title={t('legal.privacy-policy')} url={PLETLY_PRIVACY_POLICY_URL} {...textProps}>
			{children || t('legal.privacy-policy')}
		</WebLink>
	);
};

type Props = Omit<WebLinkProps, 'title' | 'url'>;

export const PrivacyPolicyLink = withTranslation(PrivacyPolicyLinkBase);
